module.exports = __webpack_public_path__ + "img/bg-dashboard.afa02e02.jpg";